module.exports = __webpack_public_path__ + "static/assets/6f0ba1d867c6deea16ff16c9e7fbc62b.png";